import React from "react";
import { Trans, useTranslation } from "react-i18next";

const Hero = () => {
  // Subscribe to i18n so the <Trans> heading re-renders on language toggle.
  // (useLanguage only calls i18n.changeLanguage; there is no app-level state
  // lift, and <Trans> does not self-subscribe to languageChanged.)
  useTranslation();

  return (
    <header
      data-w-id="836d87a6-33ac-1128-12b5-5b3710539e86"
      className="section"
    >
      <div className="container hero-center">
        <h1 className="heading-9vw">
          <Trans i18nKey="home.hero.heading" components={{ 1: <br /> }} />
        </h1>
      </div>
    </header>
  );
};

export default Hero;
